/*
 * Resin Charm builder — selection summary
 * ---------------------------------------
 * Hooks into the Globo Product Options (GPO) DOM (same app as the Bed Builder)
 * and renders a live "Your Bundle" summary of the charms a customer selects.
 *
 * There is only ONE multi-select option group ("Your Charms", rendered as
 * checkboxes) and NO discount logic. Each swatch carries its own image + name
 * in the DOM.
 *
 * The charms add nothing to the price (GPO's own total block is hidden and
 * resolves to zero), so the key ring's product price as rendered by the theme
 * IS the bundle price. The only money this file touches is the DISPLAY price on
 * the product page, which it pins so charm selections can't move it (see below).
 */
(function () {
  // Multi-select image swatches rendered by GPO for the charm picker
  var SWATCH_SELECTOR = 'input[type="checkbox"][data-type="image-swatches_multiple"]';

  var config = window.ResinCharmConfig || {};

  function getSwatchInputs() {
    return Array.prototype.slice.call(document.querySelectorAll(SWATCH_SELECTOR));
  }

  function getSelectionLimit(attr) {
    var input = document.querySelector(SWATCH_SELECTOR + '[' + attr + ']');
    var value = input ? parseInt(input.getAttribute(attr), 10) : 0;
    return isNaN(value) ? 0 : value;
  }

  // The charm count the picker is built around — the target in the "n/3" counter.
  function getTargetSelection() {
    return getSelectionLimit('data-min-selection');
  }

  // GPO only warns once you're already over its max ("Please select exactly 3
  // options") — it never stops the click. Lock the unpicked swatches at the
  // limit so the bundle can't be built wrong in the first place. Picked swatches
  // stay live so charms can still be swapped out.
  function enforceMaxSelection() {
    var max = getSelectionLimit('data-max-selection');
    if (!max) return;

    var inputs = getSwatchInputs();
    var atLimit = inputs.filter(function (i) { return i.checked; }).length >= max;

    inputs.forEach(function (input) {
      var lock = atLimit && !input.checked;
      input.disabled = lock;
      var swatch = input.closest('.gpo-swatches');
      if (swatch) swatch.classList.toggle('rc-swatch--locked', lock);
    });
  }

  function getSwatchImage(input) {
    var label = document.querySelector('label[for="' + input.id + '"]');
    if (!label) {
      var swatch = input.closest('.gpo-swatches');
      label = swatch ? swatch.querySelector('label') : null;
    }
    var img = label ? label.querySelector('img.swatch-image, img') : null;
    return img ? img.getAttribute('src') : '';
  }

  function getSwatchName(input) {
    var swatch = input.closest('.gpo-swatches');
    var title = swatch
      ? swatch.querySelector('.gpo-tooltip__title .break-word') ||
        swatch.querySelector('.gpo-tooltip__title')
      : null;
    return (title ? title.textContent : input.value || '').trim();
  }

  // Find (or create) the card we render the summary into — BELOW the options.
  function ensureContainer() {
    var existing = document.getElementById('resin-charm-summary');
    if (existing) return existing;

    var container = document.createElement('div');
    container.id = 'resin-charm-summary';
    container.className = 'resin-charm-summary';

    // 1. Directly after the charm swatch group (matches Bed Builder placement)
    var swatchGroups = document.querySelectorAll('.gpo-element[data-element-id^="image-swatches"]');
    if (swatchGroups.length) {
      var last = swatchGroups[swatchGroups.length - 1];
      last.parentNode.insertBefore(container, last.nextSibling);
      return container;
    }

    // 2. Explicit placeholder in the GPO HTML block (<div id="summary table">)
    var placeholder = document.querySelector('[id="summary table"]');
    if (placeholder) {
      placeholder.appendChild(container);
      return container;
    }

    // 3. Fallbacks
    var tabs = document.getElementById('tabs');
    if (tabs) {
      tabs.appendChild(container);
      return container;
    }
    var app = document.querySelector('.gpo-app');
    if (app) {
      app.parentNode.insertBefore(container, app.nextSibling);
      return container;
    }
    return null;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function itemHtml(name, img, extraClass) {
    return '<li class="rc-summary__item' + (extraClass ? ' ' + extraClass : '') + '">' +
      (img ? '<img class="rc-summary__img" src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') +
      '<span class="rc-summary__name">' + escapeHtml(name) + '</span>' +
      '</li>';
  }

  function plural(n, word) {
    return n + ' ' + word + (n !== 1 ? 's' : '');
  }

  function renderSummary() {
    var container = ensureContainer();
    if (!container) return;

    var checked = getSwatchInputs().filter(function (i) { return i.checked; });
    var target = getTargetSelection();

    // Progress counter lives in the title row — it replaces the old
    // "choose at least 3" hint as the running nudge toward a full stack.
    var html = '<div class="rc-summary__head">' +
      '<span class="rc-summary__title">Your Bundle</span>' +
      (target
        ? '<span class="rc-summary__progress' +
          (checked.length >= target ? ' is-complete' : '') + '">' +
          checked.length + '/' + target + '</span>'
        : '') +
      '</div>';

    html += '<ul class="rc-summary__list">';

    // The key ring itself is always part of the bundle — list it above the charms.
    html += itemHtml(config.title || 'Key Ring', config.image, 'rc-summary__item--base');

    checked.forEach(function (input) {
      html += itemHtml(getSwatchName(input), getSwatchImage(input));
    });

    html += '</ul>';

    html += '<div class="rc-summary__footer">' +
      '<span class="rc-summary__selection">1 Key Ring + ' +
      plural(checked.length, 'Charm') + ' Selected</span>' +
      '</div>';

    // Note: no min-selection hint here — GPO renders its own
    // "Please select at least 3 options" message (restyled in our CSS).

    container.innerHTML = html;
  }

  function update() {
    enforceMaxSelection();
    renderSummary();
  }

  // Delegated listener — fires no matter when GPO injects the checkboxes.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches(SWATCH_SELECTOR)) {
      update();
    }
  });

  // Signature "mix & match" pill next to the product title (Bed Builder style).
  function addBundlePill() {
    if (document.querySelector('.rc-bundle-pill')) return;
    var title =
      document.querySelector('.product-title') ||
      document.querySelector('.product-info h1') ||
      document.querySelector('h1.product-title');
    if (!title) return;
    var pill = document.createElement('span');
    pill.className = 'rc-bundle-pill';
    pill.textContent = 'mix & match';
    title.appendChild(pill);
  }

  // GPO dispatches this once its markup is in place (some themes fire it).
  document.addEventListener('gpoElementChanged', update);

  // Initial paint — poll/observe until GPO has rendered the swatches.
  function tryInit() {
    addBundlePill();
    if (getSwatchInputs().length > 0) {
      update();
      return true;
    }
    return false;
  }

  if (!tryInit()) {
    var observer = new MutationObserver(function () {
      if (tryInit()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  /*
   * Fixed display price
   * -------------------
   * The key ring bundle is ONE price: picking charms must not move the number.
   * GPO rewrites the price element as charms are selected, so rather than react
   * to those writes we pin the price and put it straight back every time.
   *
   * The value comes from window.ResinCharmConfig, which Liquid renders through
   * the theme's own money filter — already in the customer's market currency and
   * formatted exactly like every other price, so nothing here is currency-aware
   * and nothing is hardcoded.
   */

  // Only the product's own price — never the cards for recommended/related products.
  var PRICE_TARGETS = [
    { selector: '.product-info__price .price__current', source: 'price' },
    { selector: '.sticky-atc-panel .price__current', source: 'price' },
    { selector: '.product-info__price .price__was', source: 'compareAtPrice' },
    { selector: '.sticky-atc-panel .price__was', source: 'compareAtPrice' }
  ];

  var pinnedPrices = null;

  // Read once, on first paint — before GPO has had a chance to touch anything.
  function getPinnedPrices() {
    if (pinnedPrices) return pinnedPrices;

    pinnedPrices = {};

    PRICE_TARGETS.forEach(function (target) {
      if (pinnedPrices.hasOwnProperty(target.source)) return;

      var value = config[target.source];

      // Fallback for a stale theme.liquid: use whatever the theme rendered into
      // the element. Only safe this early, which is why it is read once and kept.
      if (!value) {
        var el = document.querySelector(target.selector);
        value = el ? el.textContent : '';
      }

      if (value) pinnedPrices[target.source] = value;
    });

    return pinnedPrices;
  }

  function holdPrice() {
    var prices = getPinnedPrices();

    PRICE_TARGETS.forEach(function (target) {
      var value = prices[target.source];
      if (!value) return;

      Array.prototype.forEach.call(document.querySelectorAll(target.selector), function (el) {
        if (el.textContent !== value) el.textContent = value;
      });
    });
  }

  // GPO (and the theme's own variant picker) can rewrite the price at any point,
  // so watch and put it straight back. Our own writes settle immediately: the
  // text already matches, so the next pass is a no-op and this cannot loop.
  function watchPrices() {
    var queued = false;

    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        holdPrice();
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function initPrice() {
    holdPrice();
    watchPrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrice);
  } else {
    initPrice();
  }

})();
